<template>
  <div class="reference-conclusions">
    <p class="reference-conclusions__lead">
      Уровень ЭИ выше в группе с высокими KPI.
    </p>

    <template v-if="importantCards.length">
      <p class="reference-conclusions__text">
        {{ detectedText }}
        <span class="conclusion-bold">{{ importantCards.length }} {{ keyWordText }} {{ parameterWordText }}</span>,
        показатели {{ relationWordText }} критически важны для эффективности специалиста по работе с клиентами,
        для фокусного развития и выбора специалистов в кадровый резерв, которые потенциально будут более эффективны
        в достижении KPI.
      </p>

      <ol class="reference-conclusions__list">
        <li
            v-for="card in importantCards"
            :key="card.key || card.title"
        >
          {{ card.title }}
        </li>
      </ol>

      <p class="reference-conclusions__text">
        На остальные показатели также можно ориентироваться и выбирать не ниже указанных баллов на графике,
        но наибольший вклад в достижение KPI вносят именно эти параметры.
      </p>
    </template>

    <template v-else>
      <p class="reference-conclusions__text">
        Статистически значимые ключевые параметры по текущей выборке не выявлены. При кадровых решениях можно
        ориентироваться на рекомендуемые границы по графику, но без выделения отдельных параметров как приоритетных.
      </p>
    </template>

    <a-button
        data-html2canvas-ignore
        class="primary-button reference-conclusions__button"
        @click="$emit('show-staffs')"
    >
      Смотреть подходящих сотрудников
    </a-button>
  </div>
</template>

<script>
import { computed } from "vue";
import { getWordFormBasedOnTheCount } from "@/views/Report/utils";

export default {
  name: "ReferenceConclusionBlock",

  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["show-staffs"],

  methods: {
    getWordFormBasedOnTheCount,
  },

  setup(props) {
    const importantCards = computed(() => {
      return props.cards
          .filter((card) => card.important)
          .sort((cardA, cardB) => {
            return Number(cardA.graphic_order || 0) - Number(cardB.graphic_order || 0);
          });
    });

    const importantCount = computed(() => {
      return importantCards.value.length;
    });

    const detectedText = computed(() => {
      return getWordFormBasedOnTheCount(
          importantCount.value,
          "Выявлен",
          "Выявлены",
          "Выявлены"
      );
    });

    const keyWordText = computed(() => {
      return getWordFormBasedOnTheCount(
          importantCount.value,
          "ключевой",
          "ключевых",
          "ключевых"
      );
    });

    const parameterWordText = computed(() => {
      return getWordFormBasedOnTheCount(
          importantCount.value,
          "параметр",
          "параметра",
          "параметров"
      );
    });

    const relationWordText = computed(() => {
      return getWordFormBasedOnTheCount(
          importantCount.value,
          "которого",
          "которых",
          "которых"
      );
    });

    return {
      importantCards,
      detectedText,
      keyWordText,
      parameterWordText,
      relationWordText,
    };
  },
};
</script>

<style lang="scss" scoped>
.reference-conclusions {
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.85);

  .conclusion-bold {
    font-weight: 600;
  }
}

.reference-conclusions__lead {
  margin: 0 0 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.85);
}

.reference-conclusions__text {
  max-width: 800px;
  margin: 0 0 16px;
}

.reference-conclusions__list {
  margin: 0 0 16px;
  padding-left: 32px;
}
</style>